export const UPDATE_INTENT_STATE = "UPDATE_INTENT_STATE"
export const INTENT_CREATED = "INTENT_CREATED"
export const INTENT_DELETED = "INTENT_DELETED"
export const INTENT_ANALYTICS_UPDATE = "INTENT_ANALYTICS_UPDATE"
